import { useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

export function usePageTracking() {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        const { error } = await supabase.functions.invoke('track-pageview', {
          body: {
            page_path: window.location.pathname,
            referrer: document.referrer || null,
          }
        })
        
        if (error && import.meta.env.DEV) {
          console.warn('Error tracking page view:', error)
        }
      } catch {
        // Silently fail - analytics shouldn't break the app
      }
    }

    // Track after a small delay to ensure page is fully loaded
    const timer = setTimeout(trackPageView, 1000)
    
    return () => clearTimeout(timer)
  }, [])
}
